// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../resources/images/line-poncho.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topbar {
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 999;
}

.topbar .topbar-left {
    background: #FFFFFF ! important;
    float: left;
    text-align: center;
    height: 70px;
    position: relative;
    width: 240px;
    z-index: 1;
}


.topbar .topbar-left {
    box-shadow: 0 4px 7px -5px #777;
    background-color: #348cd4;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-size: auto 3px !important;
    background-repeat: no-repeat !important;
    background-position: right bottom !important;
    padding: 10px 0 0 0 !important;

}

.button-menu-mobile {
    border: none;
    color: #ffffff;
    display: inline-block;
    height: 36px;
    width: 36px;
    background-color: #348cd4;
    border-radius: 2px;
    border: 1px solid #4998d8;
    font-size: 16px;
}

.color-fijo {
    color: #fff;    
}

.color-fijo:active {
    color: #fff;    
}

.waves-effect {
    position: relative;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
}

.dropdown-menu.show {
    display: block;
}

.notify-list {
    padding: 10px;
}

.dropdown-menu-right {
    right: 0;
    left: auto;
}

.dropdown-menu {
    box-shadow: 0 0 8px 0 rgb(0 0 0 / 6%), 0 1px 0 0 rgb(0 0 0 / 2%);
    border: 1px solid rgba(152, 166, 173, 0.15);
}

.dropdown-menu > li > a {
    padding: 7px 20px;
    font-size: 14px;
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: .25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #212529 !important;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
}

.dropdown-divider {
    height: 0;
    margin: .5rem 0;
    overflow: hidden;
    border-top: 1px solid #e9ecef;
}

.nav > li > a:hover, .nav > li > a:focus {
    text-decoration: none;
    background-color: transparent;
}

a:active, a:hover {        
    color: #0056b3 !important;
}

.nav .open > a {
    background-color: transparent !important;
}

.enlarged {
    min-height: 1250px;
}

.content-page-fit {
    margin-left: 70px;
}

.side-fit {
    width: 70px !important;
}

.side-footer {
    left: 70px;
}

.menu-item {
    color: inherit !important;
}
.logo img {
    margin-top: 5px !important;
    width: 169px;
    height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Home/Header/topbar.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;;AAGA;IAGI,+BAA+B;IAC/B,yBAAyB;IACzB,oEAA2E;IAC3E,oCAAoC;IACpC,uCAAuC;IACvC,4CAA4C;IAC5C,8BAA8B;;AAElC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IAGzB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IAEI,gEAAgE;IAChE,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;IAC1B,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".topbar {\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 999;\n}\n\n.topbar .topbar-left {\n    background: #FFFFFF ! important;\n    float: left;\n    text-align: center;\n    height: 70px;\n    position: relative;\n    width: 240px;\n    z-index: 1;\n}\n\n\n.topbar .topbar-left {\n    -moz-box-shadow: 0 4px 7px -5px #777;\n    -webkit-box-shadow: 0 4px 7px -5px #777;\n    box-shadow: 0 4px 7px -5px #777;\n    background-color: #348cd4;\n    background-image: url(../../../resources/images/line-poncho.png) !important;\n    background-size: auto 3px !important;\n    background-repeat: no-repeat !important;\n    background-position: right bottom !important;\n    padding: 10px 0 0 0 !important;\n\n}\n\n.button-menu-mobile {\n    border: none;\n    color: #ffffff;\n    display: inline-block;\n    height: 36px;\n    width: 36px;\n    background-color: #348cd4;\n    border-radius: 2px;\n    border: 1px solid #4998d8;\n    font-size: 16px;\n}\n\n.color-fijo {\n    color: #fff;    \n}\n\n.color-fijo:active {\n    color: #fff;    \n}\n\n.waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.dropdown-menu.show {\n    display: block;\n}\n\n.notify-list {\n    padding: 10px;\n}\n\n.dropdown-menu-right {\n    right: 0;\n    left: auto;\n}\n\n.dropdown-menu {    \n    -webkit-box-shadow: 0 0 8px 0 rgb(0 0 0 / 6%), 0 1px 0 0 rgb(0 0 0 / 2%);\n    box-shadow: 0 0 8px 0 rgb(0 0 0 / 6%), 0 1px 0 0 rgb(0 0 0 / 2%);\n    border: 1px solid rgba(152, 166, 173, 0.15);\n}\n\n.dropdown-menu > li > a {\n    padding: 7px 20px;\n    font-size: 14px;\n}\n\n.dropdown-item {\n    display: block;\n    width: 100%;\n    padding: .25rem 1.5rem;\n    clear: both;\n    font-weight: 400;\n    color: #212529 !important;\n    text-align: inherit;\n    white-space: nowrap;\n    background-color: transparent;\n    border: 0;\n}\n\n.dropdown-divider {\n    height: 0;\n    margin: .5rem 0;\n    overflow: hidden;\n    border-top: 1px solid #e9ecef;\n}\n\n.nav > li > a:hover, .nav > li > a:focus {\n    text-decoration: none;\n    background-color: transparent;\n}\n\na:active, a:hover {        \n    color: #0056b3 !important;\n}\n\n.nav .open > a {\n    background-color: transparent !important;\n}\n\n.enlarged {\n    min-height: 1250px;\n}\n\n.content-page-fit {\n    margin-left: 70px;\n}\n\n.side-fit {\n    width: 70px !important;\n}\n\n.side-footer {\n    left: 70px;\n}\n\n.menu-item {\n    color: inherit !important;\n}\n.logo img {\n    margin-top: 5px !important;\n    width: 169px;\n    height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
